/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const CloseSolidCircleIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="20px"
      width="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3333 10C18.3333 14.6024 14.6024 18.3334 10 18.3334C5.39763 18.3334 1.66667 14.6024 1.66667 10C1.66667 5.39765 5.39763 1.66669 10 1.66669C14.6024 1.66669 18.3333 5.39765 18.3333 10ZM9.11569 10L6.22392 7.10824L7.10779 6.22437L9.99956 9.11613L12.8912 6.22442L13.7751 7.1083L10.8834 10L13.7751 12.8917L12.8913 13.7756L9.99956 10.8839L7.10779 13.7757L6.22392 12.8918L9.11569 10Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
